const theme = {
  id: "dark",
  primaryColor: "#25293D",
  secondaryColor: "#601C4E",
  thirdColor: "#777",
  bodyBackgroundColor: "#000",
  formBackgroundColor: "#666",
  bodyFontColor: "#fff",
}

export default theme
